<p class="debugMessage"><small>data-integrations:</small></p>
@if(selectedOrganisation && selectedAccount && webhookIntegrationTypes){
<div class="nav-div">
	<nav class="navbar navbar-expand-lg alignRow" style="height: var(--navBar-Height);">
		<span style="font-weight: bold;">{{selectedOrganisation.Name}}&nbsp;Integrations</span>
		<span class="me-auto"></span>
		<span class="alignRow" style="padding-left: var(--default-padding);font-weight: bold;font-size: larger;">
			<mat-button-toggle-group [value]="showWebhooks" class="no-tick compact-toggle"
				(change)="toggleButtonGroupFilter($event.value)">
				<mat-button-toggle *ngFor="let btn of BGSelection" [value]="btn.Id" title="{{ btn.Value }}"
					[ngStyle]="{'color': btn.Color}">
					<mat-icon *ngIf="btn.Icon">{{ btn.Icon }}</mat-icon>
					<span *ngIf="!btn.Icon">{{btn.Value}}</span>
				</mat-button-toggle>
			</mat-button-toggle-group>
		</span>
		<span class="alignRow app-icon app-icon--add" mat-icon-button
			*ngIf="selectedAccount.Admin && webhookIntegrationTypes.length > 0"
			[matMenuTriggerFor]="newIntegrationMenu"><mat-icon /></span>
	</nav>
</div>
<div class="tab-div">
	<ejs-tab id="element" headerPlacement="Top" *ngIf="WebhooksLoaded" style="margin: 1em;margin-left: 0px;"
		(selected)="refresh()" [selectedItem]="selectedTab">
		<e-tabitems>
			<ng-container *ngFor="let type of webhookIntegrationTypes">
				<e-tabitem *ngIf="webhookTypes[type.WebhookTypeID]?.webhooks?.length">
					<ng-template #headerText>
						<div>
							<span class="alignRow">
								<span *ngIf="type.NeuronSensors">
									<img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/neuron-board-icon.ico"
										style="max-width: 30px; max-width: 30px;">&nbsp;
								</span>
								<span *ngIf="type.Path.includes('omron')">
									<img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/omronfavicon2.ico"
										style="max-width: 30px; max-width: 30px;">&nbsp;
								</span>
								<span>{{type.Type}}</span>
							</span>
						</div>
					</ng-template>
					<ng-template #content>
						<ng-container [ngTemplateOutlet]="webhooks"
							[ngTemplateOutletContext]="{ data: webhookTypes[type.WebhookTypeID]['webhooks'] }"></ng-container>
					</ng-template>
				</e-tabitem>
			</ng-container>
		</e-tabitems>
	</ejs-tab>
</div>
}
<div class="outlet-div">
	<hr>
	<router-outlet></router-outlet>
</div>

<ng-template #webhooks let-data="data">
	<div style="margin:0.5em" *ngIf="data.length == 0">
		<span>No Integrations found for this filter</span>
	</div>

	<div style="margin:0.5em" *ngIf="data.length > 0">
		<div class="webhookGrid gridRow gridRowH" style="font-weight: bold;">
			<div class="gridIcon"></div>
			<div class="gridClientID">ID:</div>
			<div class="gridSensors">Sensors:</div>
			<div class="gridDatapoints">Datapoints:</div>
			<div class="gridDescription">Description:</div>
			<div class="gridPath">Path:</div>
			<div class="gridClipboard"></div>
			<!-- <div class="gridEnable">Enabled:</div> -->
			<div class="gridEnable"></div>
			<div class="gridEdit"></div>
			<div class="gridClear"></div>
		</div>
		<!-- [ngClass]="{'highlightRow': integration.WebhookID == selectedIntegration?.WebhookID && !integration.Offline}" -->
		<div class="webhookGrid gridRow alignRow" *ngFor="let integration of data" [ngClass]="{'offlineRow': integration.Offline == true,
						'highlightRow': integration.WebhookID == selectedIntegration?.WebhookID }" (click)="SelectRow(integration)"
			routerLink="integration/{{integration.WebhookUID}}" [queryParams]="{ isneuron: integration.NeuronSensors }">
			<div class="gridIcon-h"></div>
			<div class="gridClientID-h">ID:</div>
			<div class="gridSensors-h">Sensors:</div>
			<div class="gridDatapoints-h">Datapoints:</div>
			<div class="gridDescription-h">Description:</div>
			<div class="gridPath-h">Path:</div>
			<!-- <div class="gridEnable-h">Enabled:</div> -->
			<div class="gridEnable-h"></div>
			<div class="gridEdit-h"></div>
			<div class="gridClear-h"></div>

			<span class="gridIcon alignRow app-icon app-icon--webhook"
				[ngStyle]="{'color': integration.Enabled != true ? 'red' :''}">
				<mat-icon />
			</span>

			<span class="gridClientID alignRow">
				<span style="margin-right: 1em;"
					title="Last Received Data: {{convertEpoch(integration.LastValueReceived)}}">{{integration.ClientWebhookID}}</span>
				<span class="app-icon app-icon--error"></span>
				@if (integration.Offline) {
				<mat-icon title="Webhook Offline: Last Data {{convertEpoch(integration.LastValueReceived)}}" />
				}
				@if (integration.NeuronSensors) {
				<span [ngSwitch]="ValidateNeuronSensorIntegration(integration)">
					<span class="app-icon app-icon--warning" *ngSwitchCase="'Warning'"
						style="color: gold; background-color: whitesmoke;"><mat-icon
							title="NeuronSensor Integration has Errors" /> </span>
					<span class="app-icon app-icon--warning" *ngSwitchCase="'Disabled'"
						style="color: red; background-color: whitesmoke;"><mat-icon
							title="NeuronSensor Integration is disabled" /> </span>
				</span>
				}
			</span>
			<span class="gridSensors ">
				<span>{{integration.SensorOnlineCount}}/{{integration.SensorCount}}</span>
				<span class="app-icon app-icon--warning">
					<mat-icon *ngIf="integration.SensorOnlineCount != integration.SensorCount"
						title="One or more sensors Offline" />
				</span>
			</span>
			<span class="gridDatapoints">
				<span>{{integration.DatapointOnlineCount}}/{{integration.DatapointCount}}</span>
				<span class="app-icon app-icon--warning">
					<mat-icon *ngIf="integration.DatapointOnlineCount != integration.DatapointCount"
						title="One or more data points Offline" />
				</span>
			</span>
			<span class="gridDescription"><span>{{integration.Description}}</span></span>
			<span class="gridPath" style="padding: 0px;">
				<!-- style="background-color: lightgrey;padding: 5px; border-radius: 5px;" -->
				<span title="{{integration.FQN}}?code={{integration.TypeAzureCode}}">
					<span style="padding:0px">{{integration.FQN}}</span>
					<span style="padding:0px"
						*ngIf="integration.TypeAzureCode">?code={{integration.TypeAzureCode}}</span>
				</span>
			</span>
			<span class="gridClipboard" title="Copy Path to Clipboard" (click)="copyToClipboard(integration)">
				<!-- <mat-icon>content_copy</mat-icon> -->
				&nbsp;
			</span>
			<span class="gridEnable alignRow gridHover gridMenu">
				<span>Enabled:</span>
				<mat-slide-toggle [(ngModel)]="integration.Enabled" color="primary" [disabled]="!selectedAccount.Admin"
					(mousedown)="toggleChange($event, integration)"></mat-slide-toggle>
			</span>
			<span class="gridEdit gridHover gridMenu">
				<span mat-icon-button class="app-icon app-icon--edit" (click)="editIntegration(integration)"
					[attr.disabled]="!selectedAccount.Admin">
					<mat-icon />
				</span>
			</span>
			<span class="gridClear ">
				<span mat-icon-button class="app-icon app-icon--delete gridHover gridMenu"
					(click)="deleteIntegration(integration)" [attr.disabled]="!selectedAccount.Admin">
					<mat-icon />
				</span>
			</span>
		</div>
	</div>
</ng-template>

<mat-menu #newIntegrationMenu [overlapTrigger]="false" yPosition="above" xPosition="after">
	@for (type of webhookIntegrationTypes; track type.WebhookTypeID) {
	@if (type.IsAllowed) {
	<button mat-menu-item (click)="addIntegration(type.WebhookTypeID)">
		<mat-icon>webhook</mat-icon><span>{{type.Type}}</span>
	</button>
	}
	}
	<!-- <ng-container *ngFor="let type of webhookIntegrationTypes as IIntegratonType">
		<button mat-menu-item *ngIf="type.IsAllowed" (click)="addIntegration(type.WebhookTypeID)">
			<mat-icon>webhook</mat-icon><span>{{type.Type}}</span>
		</button>
	</ng-container> -->
</mat-menu>